export default __webpack_public_path__ + "static/media/user.8343c2bf.png";